// The ONLY runtime reader of `import.meta.env.VITE_SITE`. Every other module that
// needs the active site imports SITE / SITE_CONFIG from here — never re-reads the env var.
import { type BuildSiteId, SITE_CONFIGS } from "~/siteConfigs";

const raw = import.meta.env.VITE_SITE;
export const SITE: BuildSiteId = raw === "appcoil" ? "appcoil" : "slate";
export const SITE_CONFIG = SITE_CONFIGS[SITE];
